import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Drawer, Box, IconButton, Divider } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import DefinitionContext from './context';
import { useStyles, styles } from './styles';
import { getChartType, getContentComponent } from './util';
import { colors } from '../../theme/color-palette';
export { DefinitionContext, getChartType };
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';

/**
 * This is a Drawer(open from right), that shows different Metric definitions, and details of Charts(On Hand, Inventory etc)
 * It opens when user clicks on the Card title.
 */
const Definition = ({ isOpen, metricType, onClose }) => {
	const classes = useStyles();
	const data = getContentComponent(metricType);
	if (isOpen) {
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.METRIC_DEFINITIONS,
		});
	}

	let contentComp = null;

	if (metricType === 'anomaly') {
		contentComp = (
			<Fragment>
				{/* Title - Definition */}
				{data?.metric && (
					<Box className={classes.contentBlockStyle1}>
						{data?.metric.title}
						{data?.metric.content}
					</Box>
				)}
				{/* Formula */}
				{data?.performaing && (
					<Box className={classes.contentBlockStyle1}>
						{data?.performaing.title}
						{data?.performaing.content}
					</Box>
				)}
				{/* Aggregation Logic */}
				{data?.logic && (
					<Box className={classes.contentBlockStyle1}>
						{data?.logic.title}
						{data?.logic.content}
					</Box>
				)}
				{data?.window && (
					<Box className={classes.contentBlockStyle3}>
						{data?.window.title}
						{data?.window.content}
					</Box>
				)}
			</Fragment>
		);
	} else if (metricType === 'in-transit' || metricType === 'wos') {
		contentComp = (
			<Fragment>
				{data?.metricsAndFormulae &&
					data?.metricsAndFormulae?.map(({ metric, formula }, i) => (
						<Fragment key={i}>
							{/* Title & Definition */}
							{metric && (
								<Box className={classes.contentBlockStyle2}>
									{metric?.title}
									{metric?.content}
								</Box>
							)}
							{/* Formula */}
							{formula && (
								<Box className={classes.contentBlockStyle2}>
									{formula?.title}
									{formula?.content}
								</Box>
							)}
							<Divider className={classes.divider} />
						</Fragment>
					))}
				{/* Aggregation Logic */}
				{data?.logic && (
					<Box className={classes.contentBlockStyle2}>
						{data?.logic.title}
						{data?.logic.content}
					</Box>
				)}
			</Fragment>
		);
	} else if (metricType === 'channel-breakdown') {
		const subContentCallBack = ({ title, content }, i) => (
			<Fragment key={i}>
				{title}
				{content}
			</Fragment>
		);
		contentComp = (
			<Fragment>
				{data?.store && (
					<Box className={classes.contentBlockStyle1}>
						{/* Title */}
						{data?.store.title}
						{/* Contents */}
						{data?.store.content?.map(subContentCallBack)}
					</Box>
				)}
				{data?.eComm && (
					<Box className={classes.contentBlockStyle1}>
						{/* Title */}
						{data?.eComm.title}
						{/* Contents */}
						{data?.eComm.content?.map(subContentCallBack)}
					</Box>
				)}
			</Fragment>
		);
	} else {
		contentComp = (
			<Fragment>
				{/* Title - Definition */}
				{data?.metric && (
					<Box className={classes.contentBlockStyle1}>
						{data?.metric.title}
						{data?.metric.content}
					</Box>
				)}
				{/* Formula */}
				{data?.formula && (
					<Box className={classes.contentBlockStyle1}>
						{data?.formula.title}
						{data?.formula.content}
					</Box>
				)}
				{/* Aggregation Logic */}
				{data?.logic && (
					<Box className={classes.contentBlockStyle1}>
						{data?.logic.title}
						{data?.logic.content}
					</Box>
				)}
			</Fragment>
		);
	}

	return (
		<Drawer
			anchor={'right'}
			open={isOpen}
			elevation={1}
			onClose={onClose}
			ModalProps={{
				BackdropProps: {
					style: { backgroundColor: colors.WHITE, opacity: '0.7' },
				},
			}}>
			<Box
				className={classes.container}
				data-test-id="metrics-definition-drawer">
				{/* Header - Metrics Definition */}
				<Box className={classes.header}>
					<Typography sx={{ ...styles.title }}>
						{metricType === 'anomaly' ? 'Anomaly' : 'Metrics Definition(s)'}
					</Typography>
					<IconButton
						style={{ ...styles.closeButton }}
						aria-label="close-button"
						data-test-id="close-definition-drawer"
						onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</Box>
				{contentComp}
			</Box>
		</Drawer>
	);
};

Definition.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	metricType: PropTypes.string,
};

export default React.memo(Definition);
